import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: "app-view-image",
  templateUrl: "./view-image.component.html",
  styleUrls: ["./view-image.component.scss"]
})
export class ViewImageComponent implements OnInit {
  dataImage: [];
  lastimg: any;

  constructor(
    public dialogRef: MatDialogRef<ViewImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.dataImage = data.imglist;
    this.lastimg = data.img;
    console.log(data);
  }

  ngOnInit() {}
  onNoClick(): void {
    this.dialogRef.close();
  }
}
